import React, { Component } from "react";
import { connect } from "react-redux";

import { RegisterTableContainer } from "./index";
import { RegisterTableHead } from "./head";
import { AddedRowsTableBody, EditableRegisterTableBody, EmptyRegisterTableBody, ReadOnlyRegisterTableBody } from './body'
import { EditableRowsMessage, ReadOnlyRowsMessage } from "./messages";

import { incrementPageCount } from "../../core/actions/pagination";
import { createAddedRow } from "../../core/actions/editing";
import { AddIcon } from "../icons";
import { TopScrollBar } from "./topScrollBar";


class _EditableRegisterTable extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // for smaller registers it is very likely that the editable content will fill less than
        // a whole page. Therefore we want to show the first page of read only content pre-loaded as well.
        // The most semantic way to do this is to actually increment the page counter and re-render.
        if ( this.contentDoesNotFillAPage() ) {
            this.props.dispatch( incrementPageCount() )
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // for smaller registers it is very likely that the editable content will fill less than
        // a whole page. Therefore we want to show the first page of read only content pre-loaded as well.
        // The most semantic way to do this is to actually increment the page counter and re-render.
        if ( this.contentDoesNotFillAPage() ) {
            this.props.dispatch( incrementPageCount() )
        }
    }

    contentDoesNotFillAPage() {
        const { chunkedEditableRowKeys , pageCount, rowsPerPage } = this.props;

        if ( pageCount <= chunkedEditableRowKeys.length ) {
            // page count is 1-indexed, but arrays are 0-indexed, so we offset
            const chunkedEditableRows = chunkedEditableRowKeys[pageCount - 1];
            return chunkedEditableRows.length < rowsPerPage
        }
    }

    editablePageCount() {
        return this.props.chunkedEditableRowKeys.length
    }

    readOnlyPageCount() {
        return this.props.chunkedReadOnlyRowKeys.length
    }

    totalPageCount() {
        return this.editablePageCount() + this.readOnlyPageCount()
    }

    calculateReadOnlyPageOffset(pageCount, editablePageCount) {
        let offset = pageCount - editablePageCount;
        if ( offset === 0 ) {
            // we want an offset of 1 at minimum.
            offset = 1;
        }
        return offset
    }


    render() {

        const { addedRows, canAddRows, chunkedReadOnlyRowKeys, chunkedEditableRowKeys,
            pageCount, rowsPerPage, numTableColumns, } = this.props;

        const paginatedEditableRowKeys = [].concat(...chunkedEditableRowKeys.slice(0, pageCount));

        let paginatedReadOnlyRowKeys = [];
        // we only need to calculate the read only page content if we are going to be viewing it.
        if ( pageCount > this.editablePageCount() || chunkedEditableRowKeys[0].length < rowsPerPage ) {
            const pageOffset = this.calculateReadOnlyPageOffset(pageCount, this.editablePageCount());
            paginatedReadOnlyRowKeys = [].concat(...chunkedReadOnlyRowKeys.slice(0, pageOffset));
        }

        return (
            <div>
                <TopScrollBar />
                <RegisterTableContainer loadMoreConditional={ this.totalPageCount() > pageCount }>

                    <RegisterTableHead />

                    <EditableRowsMessage
                        numTableColumns={numTableColumns}
                    />

                    { canAddRows &&
                        [
                            <AddRowsControl
                                key={ 'addedRows.control' }
                                numTableColumns={numTableColumns}
                            />,
                            ( addedRows && <AddedRowsTableBody key={ 'addedRows.content' } /> )
                        ]
                    }

                    { paginatedEditableRowKeys.length === 0 ?
                        <EmptyRegisterTableBody
                            numTableColumns={numTableColumns}
                        /> :
                        <EditableRegisterTableBody rowKeys={ paginatedEditableRowKeys } />
                    }

                    { pageCount > chunkedEditableRowKeys.length && (
                        [
                            <ReadOnlyRowsMessage
                                key={ 'readOnlyRow.message' }
                                numTableColumns={numTableColumns}
                            />,
                            (
                                paginatedReadOnlyRowKeys.length === 0 ?
                                <EmptyRegisterTableBody
                                    key={ 'readOnlyRow.content' }
                                    numTableColumns={numTableColumns}
                                /> :
                                <ReadOnlyRegisterTableBody key={ 'readOnlyRow.content'} rowKeys={ paginatedReadOnlyRowKeys } />
                            )
                        ]
                    )}
                </RegisterTableContainer>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    addedRows: state.mutableEditing.addedRows,
    canAddRows: state.immutableEditing.canAddRows,
    chunkedReadOnlyRowKeys: state.mutablePagination.chunkedReadOnlyRowKeys,
    chunkedEditableRowKeys: state.mutablePagination.chunkedEditableRowKeys,
    pageCount: state.mutablePagination.pageCount,
    rowsPerPage: state.immutablePagination.rowsPerPage,
    fields: state.immutableBaseData.fields,
    numTableColumns: state.immutableInterface.numTableColumns,
});

export const EditableRegisterTable = connect(mapStateToProps)(_EditableRegisterTable);


class _AddRowsControl extends Component {
    handleClick(e) {
        e.preventDefault();
        this.props.dispatch( createAddedRow() );
    }

    render() {
        const { numTableColumns } = this.props;
        return (
            <tbody className="u-hidden-small">
                <tr>
                    <td className="u-position-relative u-br-none u-bg-none">
                        <AddIcon />
                        <button
                            className="btn-reset cursor-pointer u-color-blue u-text-bold"
                            onClick={(e) => this.handleClick(e)}
                        >
                            Add a new row
                        </button>
                    </td>
                    <td colSpan={numTableColumns - 1}>&nbsp;</td>
                </tr>
            </tbody>
        )
    }
}

const AddRowsControl = connect()(_AddRowsControl);
